import React from 'react';
import { LessonBlock } from '../types';

export default function InsightList({ block }: { block: LessonBlock }) {
  return (
    <div className="pc-lesson-insights">
      {(block.groups || []).map((group, i) => (
        /* eslint-disable-next-line react/no-array-index-key */
        <div className="pc-lesson-insight" key={i}>
          <h3 className="pc-lesson-insight-title">{group.title}</h3>
          <p className="pc-lesson-p">{group.body}</p>
        </div>
      ))}
    </div>
  );
}
